module.exports = __webpack_public_path__ + "static/media/prada.d9f663d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prada.jpg
// module id = 200
// module chunks = 0